import React from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import LoadingWithLable from "../../../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../../store/userSlice";
import axios from "axios";
import nodeinstance from "../../../../../../nodeInstance";

export default function DocumentsDownloadPopup({
  PopUp,
  setPopUp,
  empData,
  list,
}) {
  console.log("employee physical data to be printed in the console",empData)
  const [checkedItems, setCheckedItems] = React.useState({});
  const [fileSelect, setItemList] = React.useState([]);
  const maxSelected = 25;

  const dispatch = useDispatch();
  const { NoDataFound, currentList } = useSearchPagination(list ? list : []);

  var titles = ["", "Document Name", "Document Upload Date"];

  const handleCheckboxChange = (event, id, list) => {
    const isChecked = event.target.checked;
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[id] = true; // Set the checkbox state to true
      } else {
        delete nextState[id]; // Remove the entry for unchecked checkboxes
      }
      return nextState;
    });
    setItemList((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });
  };

  const downloadFiles = async () => {
    for (let i = 0; i < fileSelect.length; i++) {
      const url = fileSelect[i];
      const link = document.createElement("a");
      link.href = url.file;
      link.download = url.file_name; // Customize filename if needed
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Introduce a delay before initiating the next download
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Adjust the delay time as needed
    }
    updateinstance(empData.emp_id);
  };
  const token = localStorage.getItem("nodeToken");

  const updateinstance = async (emp_id) => {
    try {
      let obj = {
        employee_id: emp_id,
      };
      const response = await nodeinstance.post(obj, `/iqama/updateinstance`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("response...............",response)
    } catch (err) {}
  };

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([id, isChecked]) => isChecked)
      .map(([id]) => id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      downloadFiles();
    }
  };
  console.log("log to be seen here.......");
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div
          className="max-w-3xl w-full  rounded-md bg-white/95 flex  flex-col p-5 relative"
          style={{ height: list.length !== 0 ? "500px" : "300px" }}
        >
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>

          <div className="flex flex-row gap-2 align-baseline">
            <label className="label ">
              <span className="label-text">EMPLOYEE NAME</span>
            </label>
            <label className="label">
              <span className="label-text">{empData.name}</span>
            </label>
          </div>

          <div className="flex flex-row gap-2 align-baseline">
            <label className="label ">
              <span className="label-text">EMPLOYEE ID</span>
            </label>
            <label className="label">
              <span className="label-text">{empData.emp_id}</span>
            </label>
          </div>

          <div className="flex flex-row gap-2 align-baseline">
            <p className="label ">
              <span className="label-text">IQAMA NUMBER</span>
            </p>
            <p className="label">
              <span className="label-text">{empData.iqama_number}</span>
            </p>
          </div>
          <div
            className={`grid grid-cols-table-iqama-document-download auto-cols-min gap-5 p-6  w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
          >
            {titles.map((t, index) => (
              <p key={index} className="font-semibold uppercase">
                {t}
              </p>
            ))}
            {list?.isLoading && <LoadingWithLable className="col-span-6" />}
            {list?.isLoading && <LoadingWithLable className="col-span-6" />}
            {!list?.isLoading && <NoDataFound />}

            {!list?.isLoading
              ? currentList?.map((listData, index) => (
                  <React.Fragment key={index}>
                    <div className="flex items-center mb-0  ">
                      <input
                        list={checkedItems}
                        type="checkbox"
                        checked={checkedItems[listData.id] || false}
                        onChange={(event) => {
                          handleCheckboxChange(event, listData.id, listData);
                        }}
                        disabled={
                          checkedItems[listData.file] &&
                          Object.values(checkedItems).filter(Boolean).length >=
                            maxSelected
                        }
                      />
                    </div>
                    <p>{listData.file_name}</p>
                    <p>{listData.date}</p>

                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))
              : ""}
          </div>
          {list.length !== 0 ? (
            <div className="flex flex-row-reverse gap-2 align-baseline">
              <button
                className="p-2 px-4 rounded-md bg-red disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                onClick={() => {
                  popOpen();
                }}
              >
                <p>Download</p>
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
}
